import { Box, ConfirmationModal, Divider, ListItem, Text } from '@modusign/design-system';

interface DeleteWorkspaceTechnicalSupportModalProps {
  resourceCounts: { document: number; externalDocument: number; template: number };
  onClose: () => void;
}

export default function DeleteWorkspaceTechnicalSupportModal({
  onClose,
  resourceCounts,
}: DeleteWorkspaceTechnicalSupportModalProps) {
  return (
    <ConfirmationModal
      confirmButtonClassName="tagContactButton"
      confirmButtonLabel="상담원 연결"
      isOpen
      maxWidth="sm"
      title="워크스페이스 삭제 안내"
      variant="warning"
      onClose={onClose}
      onConfirm={onClose}
    >
      <Text as="p" fontWeight="medium" textAlign="center">
        워크스페이스에 대량의 문서·외부문서·템플릿이 존재하는 경우
        <br />
        기술 지원을 통해 데이터 이전 및 삭제 작업이 진행됩니다.
      </Text>
      <Box
        bg="boxBackgroundNeutralBase"
        border="1px solid"
        borderColor="boxBorderNeutralBase"
        display="grid"
        mt={7}
        sx={{
          gridTemplateColumns: 'repeat(3, 1fr)',
          '& > *:not(:first-child)': {
            borderLeft: '1px solid',
            borderLeftColor: 'boxBorderNeutralBase',
          },
        }}
      >
        {[
          { title: '문서', count: resourceCounts.document },
          { title: '외부문서', count: resourceCounts.externalDocument },
          { title: '템플릿', count: resourceCounts.template },
        ].map(({ title, count }, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Box key={index} px={7} py={6}>
            <Text as="div" color="textNeutralVeryLight" fontSize="sm" fontWeight="medium" mb="2px">
              {title}
            </Text>
            <Text as="div" fontWeight="medium">
              {count.toLocaleString()}개
            </Text>
          </Box>
        ))}
      </Box>
      <Divider direction="row" my={7} />
      <Box>
        <Text as="div" fontWeight="medium" mb={4}>
          삭제 주의사항
        </Text>
        <ul>
          {[
            '개인 워크스페이스로 데이터 이전이 시작되면, 더 이상 공용 워크스페이스에 접근할 수 없습니다.',
            '활성 상태의 링크가 모두 비활성화됩니다.',
            '공용 워크스페이스의 요금제 및 예치금 환불이 진행됩니다.',
            '이전된 문서의 라벨은 모두 삭제되고, 새로운 단일 라벨로 대체됩니다.',
          ].map((v, idx) => (
            // eslint-disable-next-line react/no-array-index-key
            <ListItem key={idx} mt={idx !== 0 ? 4 : 0}>
              <Text>{v}</Text>
            </ListItem>
          ))}
        </ul>
      </Box>
    </ConfirmationModal>
  );
}
